import { useInstallPrompt } from '../../hooks/useInstallPrompt'

export function InstallBanner() {
  const { isInstallable, promptInstall, dismissPrompt } = useInstallPrompt()

  if (!isInstallable) return null

  return (
    <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-3 shadow-lg z-50">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </div>
          <div>
            <p className="font-medium text-sm sm:text-base">Install Raven Guild App</p>
            <p className="text-xs sm:text-sm text-white/80">Get quick access from your desktop or home screen</p>
          </div>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={dismissPrompt}
            className="px-3 py-1.5 text-sm text-white/80 hover:text-gray-50 transition-colors"
          >
            Later
          </button>
          <button
            onClick={promptInstall}
            className="px-4 py-1.5 bg-white text-blue-600 rounded-lg font-medium text-sm hover:bg-white/90 transition-colors"
          >
            Install
          </button>
        </div>
      </div>
    </div>
  )
}
